/**
 * Where the list's controls and results sit, drawn once. Desktop puts search,
 * tabs and the count in one bar across the top of a card holding the table;
 * tablet and phone stack them full width above the cards, with the tabs
 * scrolling sideways. The stylesheet does the arranging.
 */
import type { ReactNode } from 'react';

import './ticket-sales-campaigns-list.css';

export interface TicketSalesCampaignsListLayoutProps {
  search: ReactNode;
  tabs: ReactNode;
  /** "N campaigns", or null before the campaigns have loaded. */
  countLabel: string | null;
  /** The id the status tabs point their `aria-controls` at. */
  resultsId: string;
  children: ReactNode;
}

export function TicketSalesCampaignsListLayout({
  search,
  tabs,
  countLabel,
  resultsId,
  children,
}: TicketSalesCampaignsListLayoutProps) {
  return (
    <section className="tsc-list">
      <div className="tsc-list-bar">
        <div className="tsc-list-search">{search}</div>
        <div className="tsc-list-tabs">{tabs}</div>
        {countLabel && <span className="tsc-list-count">{countLabel}</span>}
      </div>
      <div id={resultsId} role="tabpanel" className="tsc-list-results">
        {children}
      </div>
    </section>
  );
}
